export enum ReportTab {
  Summary = 'summary',
  Content = 'content',
  Settings = 'settings',
}
